// extracted by mini-css-extract-plugin
export default {"container":"ShopReport_container__NASkL","column":"ShopReport_column__41gDW"};